// *******************************************************************************
// Form handling
// *******************************************************************************

const getEmailError = (formElement) => {
  let emailMessage = '';
  if (formElement.querySelector('[type="email"]')) {
    emailMessage = formElement.querySelector('[type="email"]').getAttribute('data-fv-email-address___message');
  }
  return emailMessage;
};

const recaptchaLoads = new Map();

const loadRecaptcha = (siteKey) => {
  if (!siteKey || window.grecaptcha?.execute) return Promise.resolve();
  if (recaptchaLoads.has(siteKey)) return recaptchaLoads.get(siteKey);

  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
  script.async = true;
  script.dataset.recaptchaSitekey = siteKey;

  const load = new Promise((resolve, reject) => {
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', reject, { once: true });
  }).catch((error) => {
    recaptchaLoads.delete(siteKey);
    script.remove();
    throw error;
  });

  recaptchaLoads.set(siteKey, load);
  document.head.appendChild(script);

  return load;
};

const handleForm = (form, formAction) => {
  const formParent = form.closest('[data-parent]');
  const formAlertError = formParent.querySelector('.form-component__alert-error');
  const recaptchaKey = form.querySelector('[data-sitekey]')?.getAttribute('data-sitekey');

  if (recaptchaKey) {
    const loadOnInteraction = () => loadRecaptcha(recaptchaKey).catch(() => {});

    form.addEventListener('focusin', loadOnInteraction);
    form.addEventListener('pointerdown', loadOnInteraction);
  }

  const emailError = getEmailError(form);
  const emailFields = formParent.querySelectorAll('input[type="email"]'); // Get all email fields

  const fieldValidators = {};
  emailFields.forEach((field) => {
    const fieldName = field.name;

    if (fieldName) {
      fieldValidators[fieldName] = {
        validators: {
          callback: {
            message: emailError,
            callback(input) {
              return validateEmail(input.value);
            },
          },
        },
      };
    }
  });

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: fieldValidators,
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input,.checkbox,.dropdown,.radio-button'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .on('core.element.validated', (e) => {
      if (e.element.hasAttribute('required')) {
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input, .checkbox, .dropdown, .radio-button');
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    })
    .on('core.form.valid', async () => {
      formParent.classList.add('show-loader');
      try {
        await loadRecaptcha(recaptchaKey);
        if (recaptchaKey) {
          await new Promise((resolve) => {
            window.grecaptcha.ready(resolve);
          });
        }
        await onFormSubmit({
          formData: {
            ...getFormValue(form, fv),
            id: localData.id,
            lang: localData.lang,
            formClass: form.querySelector('[data-form-class]')?.value,
            formKey: form.querySelector('[data-form-key]')?.value,
          },
          ...(recaptchaKey ? { recaptchaKey, recaptchaAction: formAction } : {}),
        });

        formParent.classList.remove('show-loader');
        formParent.classList.add('show-thankyou');
      } catch (error) {
        console.error(error);
        formParent.classList.remove('show-loader');
        formParent.classList.add('show-error');
        formAlertError.classList.remove('hide');
        formAlertError.innerHTML = error.response?.data?.data?.msg || formAlertError.textContent;
      }
    });
};

document.addEventListener('DOMContentLoaded', () => {
  ['newsletter-form', 'form-module', 'register-form'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleForm(form, formAction);
    }
  });
});

// Check if all inputGroups in group have same name
const inputGroupParents = document.querySelectorAll('[data-input-group-parent]');

inputGroupParents.forEach((formRow) => {
  const inputGroups = formRow.querySelectorAll('[data-input-group-field]');

  if (inputGroups.length > 1) {
    // Check if failed
    const observer = new MutationObserver(() => {
      const inputParents = formRow.querySelectorAll('[data-input-group-item]');
      const hasFailedRadio = [...inputParents].some((inputParent) =>
        inputParent.classList.contains('is-validation-failed'),
      );
      formRow.classList.toggle('failed', hasFailedRadio);
    });

    inputGroups.forEach((input) =>
      observer.observe(input.closest('[data-input-group-item]'), { attributes: true, attributeFilter: ['class'] }),
    );

    // Get the first error message and create a new div
    if (formRow.classList.contains('input-group')) {
      const errorMessage = formRow.querySelector('[data-fv-not-empty___message]');
      if (errorMessage) {
        const groupErrorMessage = document.createElement('div');
        groupErrorMessage.classList.add('fv-plugins-message-container', 'group-error');
        groupErrorMessage.innerHTML = errorMessage.getAttribute('data-fv-not-empty___message');

        formRow.appendChild(groupErrorMessage);
      }
    }
  }
});
